<template>
  <b-form @submit.stop.prevent="validateWhenSubmit" novalidate="novalidate" autocomplete="off">
    <b-tabs card class="col-sm-12">
      <b-tab title="Proposta Completa">
        <div class="row">
          <div class="col-12">
            <h3>Dados do cliente</h3>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Cliente:</strong>
                {{ proposal.client ? proposal.client.name : 'Não definido' }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>CPF/CNPJ:</strong>
                {{ proposal.client.cpf_cnpj | cpf_cnpj }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>RG/IE:</strong>
                {{ proposal.client.registration_number }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Celular:</strong>
                {{ proposal.client.cell_phone | phone }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Tel. Residencial:</strong>
                {{ proposal.client.home_phone | phone }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Tel. Comercial:</strong>
                {{ proposal.client.commercial_phone | phone }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>E-mail:</strong>
                {{ proposal.client.mail }}
              </label>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col-12">
            <h3>Dados da proposta</h3>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Num contrato:</strong>
                {{ proposal.physical_proposal }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Administradora:</strong>
                {{ proposal.administrator ? proposal.administrator.name : 'Não definido' }}
              </label>
            </div>
          </div>
          <div v-if="proposal.group" class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Grupo:</strong>
                {{ proposal.group ? proposal.group.name : 'Não definido' }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Cota:</strong>
                {{ proposal.quota ? proposal.quota : 0 }}
              </label>
            </div>
          </div>
          <div v-if="proposal.model" class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Bem:</strong>
                {{ proposal.model.manufacturer.name }} / {{ proposal.model.name }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Combustível:</strong>
                {{ proposal.fuel ? proposal.fuel.name : ''}}
              </label>
            </div>
          </div>

          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Protocolo:</strong>
                {{ proposal.protocol ? proposal.protocol : '******' }}
              </label>
            </div>
          </div>

          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Classificação:</strong>
                {{ proposal.type_sale ? proposal.type_sale.name : 'Não definido' }}
              </label>
            </div>
          </div>

          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Dt. Lançamento:</strong>
                {{ proposal.created_at | moment('DD/MM/YYYY [às] hh[h]mm[m]') }}
              </label>
            </div>
          </div>

          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Motivo aquisição:</strong>
                {{ proposal.reason_acquisition }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Condição:</strong>
                {{ proposal.condition }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Formação:</strong>
                {{ proposal.formation }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Plano simples:</strong>
                {{ proposal.option_plan }}
              </label>
            </div>
          </div>
          <div v-if="proposal.plan" class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Plano:</strong>
                {{ proposal.plan.name }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Taxa administrativa (%):</strong>
                {{ proposal.administrate_tax }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Seguro de Vida (%):</strong>
                {{ proposal.life_insurance }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Fundo de Reserva (%):</strong>
                {{ proposal.reserve_fund }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Valor Carta:</strong>
                {{ proposal.value | price }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Valor por parcela:</strong>
                {{ proposal.plot_amount | price }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Quant. Parcelas:</strong>
                {{ proposal.number_installments }}
              </label>
            </div>
          </div>
          <div v-if="proposal.proposal_status" class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Status:</strong>
                {{ proposal.proposal_status.name }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Vendedor:</strong>
                {{ proposal.salesman.name }}
              </label>
            </div>
          </div>
          <div class="col-12 col-lg-4 col-md-4 col-sm-6">
            <div class="form-group bmd-form-group">
              <label>
                <strong>Data da venda:</strong>
                {{ proposal.sale_at | moment('DD/MM/YYYY HH:mm:ss') }}
              </label>
            </div>
          </div>
        </div>
        <h3 class="info-text">Parcelas</h3>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-center">Ordem</th>
                    <th class="text-center">Estorno</th>
                    <th class="text-center">R$ Parcela</th>
                    <th class="text-center">R$ Pago</th>
                    <th class="text-center">Data Vencimento</th>
                    <th class="text-center">Data Pagamento</th>
                    <!-- <th class="text-center">Ação</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="proposal.installments.length > 0"
                    v-for="(installment, index) in proposal.installments"
                    :key="installment.id"
                  >
                    <td class="text-center">
                      {{ installment.order }}
                      <md-icon
                        class="text-blue"
                        v-if="installment.contacted"
                        title="Contato com o cliente realizado!"
                      >check</md-icon>
                    </td>
                    <td class="text-center">{{ installment.commission_reversal | price }}%</td>
                    <td class="text-center">R$ {{ installment.price | price }}</td>
                    <td class="text-center">R$ {{ sumPays(installment.pays) | price }}</td>
                    <td class="text-center">{{ installment.due_at | moment('DD/MM/YYYY') }}</td>

                    <td
                      class="text-center"
                      v-if="installment.reversal_at"
                    >Estornada em {{ installment.reversal_at | moment('DD/MM/YYYY') }}</td>
                    <td
                      class="text-center"
                      v-else-if="installment.pay_at"
                    >{{ installment.pay_at | moment('DD/MM/YYYY') }}</td>
                    <td class="text-center" v-else>Pendente</td>
                    <!-- <td class="td-actions text-right">
                      <router-link
                        data-original-title
                        v-if="proposal.proposal_status_id != 5 && installment.pay_at != null && installment.reversal_at == null"
                        title="Estornar Parcela"
                        class="btn btn-just-icon btn-round btn-danger btn-link"
                        tag="md-button"
                        :to="{'name': 'proposals.reverse-pay-installment', params: { 'id' : proposal.id, 'installment': installment.id }}"
                      >
                        <md-icon>money_off</md-icon>
                      </router-link>
                      <router-link
                        data-original-title
                        v-if="proposal.proposal_status_id != 5 && (installment.pay_at == null || installment.reversal_at != null)"
                        title="Pagar Parcela"
                        class="btn btn-just-icon btn-round btn-success btn-link"
                        tag="md-button"
                        :to="{'name': 'proposals.pay-installment', params: { 'id' : proposal.id, 'installment': installment.id }}"
                      >
                        <md-icon>attach_money</md-icon>
                      </router-link>
                      <router-link
                        data-original-title
                        v-if="proposal.proposal_status_id != 5"
                        title="Editar Parcela"
                        class="btn btn-just-icon btn-round btn-primary btn-link"
                        tag="md-button"
                        :to="{'name': 'proposals.edit-parcel', params: { 'id' : proposal.id, 'installment': installment.id }}"
                      >
                        <md-icon>edit</md-icon>
                      </router-link>
                      <md-button
                        v-if="proposal.proposal_status_id != 5 && installment.pay_at == null"
                        title="Imprimir Parcela"
                        class="btn btn-just-icon btn-round btn-info btn-link"
                      >
                        <md-icon>print</md-icon>
                      </md-button>
                    </td>-->
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5">Valor Pendente</td>
                    <td
                      class="text-center text-danger"
                    >R$ {{ sum(proposal.installments, 1) | price }}</td>
                  </tr>
                  <tr>
                    <td colspan="5">Valor Pago</td>
                    <td class="text-center text-info">R$ {{ sum(proposal.installments, 2) | price }}</td>
                  </tr>
                  <tr>
                    <td colspan="5">Valor Total</td>
                    <td class="text-center text-success">R$ {{ sum(proposal.installments) | price }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Observações">
        <div class="row">
          <div class="col-12">
            <h3>Observações</h3>
          </div>
          <div class="col-12">
            <b-tabs pills card content-class="pt-0">
              <b-tab title="Observações" active>
                <b-card-text
                  v-if="proposal.proposal_observations && proposal.proposal_observations.length > 0"
                >
                  <observation-tab
                    v-for="(observation, index) in proposal.proposal_observations"
                    :key="index"
                    :observation.sync="observation"
                  ></observation-tab>
                </b-card-text>
                <b-card-text v-else>
                  <h4>Não existe nenhuma observação cadastrada para essa proposta</h4>
                </b-card-text>
              </b-tab>
              <b-tab title="Boletos enviados">
                <b-card-text
                  v-if="proposal.installment_slips_sents && proposal.installment_slips_sents.length > 0"
                >
                  <slip-tab
                    v-for="(slip, index) in proposal.installment_slips_sents"
                    :key="index"
                    :slip.sync="slip"
                  ></slip-tab>
                </b-card-text>
                <b-card-text v-else>
                  <h4>Não existe nenhum envio de boleto para essa proposta</h4>
                </b-card-text>
              </b-tab>
            </b-tabs>
            <hr />
            <h3>Contato de pós venda</h3>
            <Contacts></Contacts>
          </div>
        </div>
      </b-tab>
      <b-tab title="Enviar Boleto">
        <SendSlips></SendSlips>
      </b-tab>
      <b-tab title="Avaliar Vendedor">
        <SalesmanEvaluations v-if="!proposal.evaluated_at"></SalesmanEvaluations>
        <h5
          v-else
        >Vendedor Avaliado</h5> 
        <label> {{evaluation.type == 1 ? 'Positivamente ' : 'Negativamente '}} em {{proposal.evaluated_at | moment('DD/MM/YYYY HH:mm:ss') }}</label>
        <h5>Observação</h5>
        <label>{{evaluation.text}}</label>
      </b-tab>
    </b-tabs>
    <div class="row">
      <div class="col-8"></div>
      <div class="col-4">
        <div class="row">
          <div class="col-sm-6">
            <router-link
              data-original-title
              title="Visualizar Proposta"
              class="btn btn-block btn-outline-warning btn-link"
              tag="button"
              :to="{'name': 'proposals.show', params: { 'id' : proposal.id }}"
            >
              <i class="material-icons">search</i> Visualizar Proposta
            </router-link>
          </div>
          <div class="col-sm-6">
            <router-link
              data-original-title
              title="Editar Proposta"
              class="btn btn-block btn-sm btn-outline-success"
              tag="button"
              :to="{'name': 'proposals.edit', params: { 'id' : proposal.id }}"
            >
            <i class="material-icons">edit</i> Editar Proposta
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import ObservationTab from "./tabs/Observations";
import SlipTab from "./tabs/Slips";
import Contacts from "./Contacts";
import SendSlips from "./SendSlips";
import SalesmanEvaluations from "./SalesmanEvaluations";
export default {
  $_veeValidate: {
    validator: "new" // give me my own validator scope.
  },
  components: {
    ObservationTab,
    SlipTab,
    Contacts,
    SendSlips,
    SalesmanEvaluations
  },
  computed: {
    installment: {
      set(installment) {},
      get() {
        return this.$store.state.charges.item.data;
      }
    },
    proposal: {
      set(proposal) {},
      get() {
        return this.$store.state.proposals.item;
      }
    }
  },
  data() {
    return {
      loading: false,
      formValidations: {
        type: {
          required: true
        },
        text: {
          required: true
        }
      },
      form: {
        type: "",
        text: ""
      },
      evaluation: {}
    };
  },
  created() {
    this.getProposal();
  },
  methods: {
    async getProposal() {
      this.$root.$emit("onLoading");

      const installment = await this.$store.dispatch(
        "charges/get",
        this.$route.params.id
      );

      const response = await this.$store.dispatch(
        "proposals/get",
        installment.data.proposal_id
      );

      const evaluation = await this.$store.dispatch(
        "charges/Evaluation",
        installment.data.proposal_id
      );

      this.$root.$emit("onLoading");

      this.form.proposal_id = installment.data.proposal_id;
      this.form.installment_id = installment.data.id;
      this.evaluation = evaluation.data;
    },
    validateWhenSubmit() {
      this.$validator.validateAll().then(isValid => {
        this.loading = false;
        if (isValid) {
          this.saveContact();
          return;
        }
      });
    },
    // async saveContact() {
    //   this.loading = true;
    //   this.$root.$emit("onLoading");

    //   const response = await this.$store.dispatch(
    //     "charges/salesmanEvaluations",
    //     this.form
    //   );

    //   this.$root.$emit("updateList");
    //   this.$notify.success(response.message);
    //   this.$router.go(-1);
    //   this.loading = false;
    //   this.$root.$emit("onLoading");
    // },
    sumPays(_pays) {
      let _sum = 0;
      if (_pays != undefined) {
        // _pays.forEach((obj, _key) => {
        _pays.forEach(obj => {
          _sum += Number(obj.value);
        });
      }

      return _sum;
    },
    async getDataProposal() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "proposals/get",
        self.$route.params.id
      );

      response.then(function() {
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    sum(_installments, _type) {
      var total = 0,
        self = this;
      switch (_type) {
        // case 1:
        //   _installments.forEach(function(_installment, _key) {
        //     if (_installment.pay_at === null) {
        //       total += _installment.price;
        //     }
        //   });
        //   break;
        case 1:
          _installments.forEach(function(_installment) {
            if (_installment.pay_at === null) {
              total += _installment.price;
            }
          });
          break;

        case 2:
          _installments.forEach(function(_installment) {
            if (_installment.pay_at !== null) {
              total += self.sumPays(_installment.pays);
            }
          });
          break;

        default:
          _installments.forEach(function(_installment) {
            total += _installment.price;
          });
      }

      return total;
    }
  }
};
</script>

<style>
</style>
